(function () {
  'use strict';

  if (typeof window.ReactNativeWebView !== 'undefined') {
    document.documentElement.setAttribute('data-bh-in-app', '1');
    return;
  }

  var ua = navigator.userAgent || '';
  var isIOS = /iPhone|iPad|iPod/i.test(ua);
  var isAndroid = /Android/i.test(ua);
  var device = isIOS ? 'ios' : (isAndroid ? 'android' : 'desktop');
  document.documentElement.setAttribute('data-bh-device', device);

  function decodeJwt(token) {
    try {
      var parts = token.split('.');
      if (parts.length < 2) return null;
      var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      var json = decodeURIComponent(atob(b64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(json);
    } catch (e) { return null; }
  }

  function readOutseta() {
    try {
      var o = window.Outseta;
      if (!o || typeof o.getAccessToken !== 'function') return { loggedIn: false, stage: null };
      var token = o.getAccessToken();
      if (!token) return { loggedIn: false, stage: null };
      var claims = decodeJwt(token);
      return { loggedIn: true, stage: null, _needsStage: true, _claims: claims, _token: token };
    } catch (e) {
      return { loggedIn: false, stage: null };
    }
  }

  function stageFromClaims(claims) {
    if (!claims) return null;
    var candidates = [
      claims['Account.AccountStage'],
      claims.AccountStage,
      claims.accountStage,
      claims.nocode && claims.nocode.accountStage,
      claims['outseta:accountStage'],
      claims['http://schemas.outseta.com/AccountStage'],
      claims.Account && claims.Account.AccountStage,
    ];
    for (var i = 0; i < candidates.length; i++) {
      var v = candidates[i];
      if (v === undefined || v === null || v === '') continue;
      var n = parseInt(v, 10);
      if (!isNaN(n)) return n;
      var s = String(v).toLowerCase();
      if (s === 'trialing') return 2;
      if (s === 'subscribing') return 3;
      if (s === 'cancelled' || s === 'canceled' || s === 'expired') return 4;
    }
    return null;
  }

  function showDebugBadge(lines) {
    if (window.location.search.indexOf('bh_debug=1') === -1) return;
    var b = document.getElementById('bh-debug-badge');
    if (!b) {
      b = document.createElement('div');
      b.id = 'bh-debug-badge';
      b.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#000;color:#0f0;font:11px monospace;padding:8px;z-index:99999;white-space:pre-wrap;max-height:40vh;overflow:auto;';
      document.body.appendChild(b);
    }
    b.textContent = '[bh-debug]\n' + lines.join('\n');
  }

  function resolveStage(state, cb) {
    if (!state._needsStage) { cb(state); return; }
    var claims = state._claims;
    var token = state._token;
    var debug = window.location.search.indexOf('bh_debug=1') !== -1;

    var jwtStage = stageFromClaims(claims);
    if (jwtStage !== null) {
      if (debug) showDebugBadge(['loggedIn: true', 'source: JWT', 'stage: ' + jwtStage]);
      state.stage = jwtStage;
      cb(state);
      return;
    }

    if (!token) { cb(state); return; }
    var timer = setTimeout(function () {
      if (debug) showDebugBadge(['loggedIn: true', 'Outseta profile fetch timed out']);
      cb(state);
    }, 5000);

    var profileUrl = 'https://bright-haven.outseta.com/api/v1/profile' +
      '?fields=Uid,Email,Account.Uid,Account.Name,Account.AccountStage,Account.AccountStageLabel';
    fetch(profileUrl, {
      headers: { Authorization: 'bearer ' + token, Accept: 'application/json' },
      credentials: 'omit',
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (user) {
      clearTimeout(timer);
      var acct = user && user.Account;
      var stage = null;
      if (acct) {
        if (typeof acct.AccountStage === 'number') stage = acct.AccountStage;
        else if (typeof acct.AccountStage === 'string') stage = parseInt(acct.AccountStage, 10);
      }
      if (debug) {
        console.log('[bh-app-cta] Outseta profile:', user);
        showDebugBadge([
          'loggedIn: true',
          'source: /profile?fields=Account.*',
          'user keys: ' + (user ? Object.keys(user).slice(0, 30).join(',') : 'null'),
          'Account present: ' + !!acct,
          'Account keys: ' + (acct ? Object.keys(acct).slice(0, 30).join(',') : 'n/a'),
          'AccountStage: ' + (acct ? typeof acct.AccountStage + ' ' + JSON.stringify(acct.AccountStage) : 'n/a'),
          'AccountStageLabel: ' + (acct ? JSON.stringify(acct.AccountStageLabel) : 'n/a'),
          'normalized stage: ' + stage
        ]);
      }
      state.stage = stage;
      cb(state);
    }).catch(function (err) {
      clearTimeout(timer);
      if (debug) showDebugBadge(['loggedIn: true', 'Outseta profile err: ' + (err && err.message || err)]);
      cb(state);
    });
  }

  function classifyUser(state) {
    if (!state.loggedIn) return 'none';
    var s = state.stage;
    if (s === 2) return 'trialing';
    if (s === 3) return 'subscribing';
    if (s >= 4) return 'expired';
    return 'unknown';
  }

  function openStore() {
    var el = document.querySelector('[data-bh-cta]');
    var cfg = el ? el.dataset : {};
    var url = device === 'android' ? (cfg.androidStore || '') : (cfg.iosStore || '');
    if (url) window.location.href = url;
  }

  function handleMobileClick(deepLink) {
    if (device === 'ios') {
      var start = Date.now();
      window.location.href = deepLink;
      setTimeout(function () {
        if (Date.now() - start < 2000 && document.hasFocus()) openStore();
      }, 1500);
    } else if (device === 'android') {
      var el = document.querySelector('[data-bh-cta]');
      var storeUrl = el && el.dataset.androidStore ? el.dataset.androidStore : '';
      var intentTail = '#Intent;scheme=brighthaven;package=com.brighthavenbooks.app;' +
        'S.browser_fallback_url=' + encodeURIComponent(storeUrl) + ';end';
      var intent;
      // Bare scheme (home mode) — open app to default screen
      if (deepLink === 'brighthaven://' || deepLink === 'brighthaven://*') {
        intent = 'intent://' + intentTail;
      } else {
        // Parse path + query from deepLink (works for brighthaven:// or https://...)
        var m = deepLink.match(/\/(open|listen)\?bookId=([^&]+)/);
        if (m) {
          intent = 'intent://' + m[1] + '?bookId=' + m[2] + intentTail;
        } else {
          intent = 'intent://' + intentTail;
        }
      }
      window.location.href = intent;
    }
  }


  function buildQRUrl(baseUrl) {
    return new Promise(function (resolve) {
      try {
        var token = (window.Outseta && typeof window.Outseta.getAccessToken === 'function') ? window.Outseta.getAccessToken() : null;
        if (!token) { resolve(baseUrl); return; }
        fetch('https://vtfi7hw6b1.execute-api.us-west-2.amazonaws.com/prod/auth/qr-issue', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
          body: '{}',
        }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || !data.code) { resolve(baseUrl); return; }
            var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
            resolve(baseUrl + sep + 'signinCode=' + encodeURIComponent(data.code));
          })
          .catch(function () { resolve(baseUrl); });
      } catch (e) { resolve(baseUrl); }
    });
  }

  function fetchSigninCode() {
    try {
      var token = (window.Outseta && typeof window.Outseta.getAccessToken === 'function') ? window.Outseta.getAccessToken() : null;
      if (!token) return Promise.resolve(null);
      return fetch('https://vtfi7hw6b1.execute-api.us-west-2.amazonaws.com/prod/auth/qr-issue', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: '{}'
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d.code; })
        .catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  function showQRModal(baseUrl) {
    var existing = document.getElementById('bh-qr-modal');
    if (existing) existing.remove();

    var modal = document.createElement('div');
    modal.id = 'bh-qr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="bh-qr-backdrop"></div>' +
      '<div class="bh-qr-card">' +
      '<button class="bh-qr-close" aria-label="Close">&times;</button>' +
      '<h3>Open in the Bright Haven app</h3>' +
      '<p>Scan with your phone to open this book.</p>' +
      '<div class="bh-qr-code" id="bh-qr-target"></div>' +
      '<p class="bh-qr-countdown" id="bh-qr-countdown" style="font-size:0.8rem;opacity:0.6;margin:0.5rem 0 1rem;">&nbsp;</p>' +
      '<div class="bh-qr-stores">' +
      '  <a href="' + getStoreUrl('ios') + '" target="_blank" rel="noopener">App Store</a>' +
      '  <a href="' + getStoreUrl('android') + '" target="_blank" rel="noopener">Google Play</a>' +
      '</div>' +
      '</div>';
    document.body.appendChild(modal);

    var QR_TTL = 300;
    var timer = null;
    var close = function () {
      if (timer) { clearInterval(timer); timer = null; }
      modal.remove();
    };
    modal.querySelector('.bh-qr-backdrop').addEventListener('click', close);
    modal.querySelector('.bh-qr-close').addEventListener('click', close);

    function renderQR(url) {
      var target = document.getElementById('bh-qr-target');
      if (!target) return;
      target.innerHTML = '';
      if (typeof window.QRCode === 'function') {
        new window.QRCode(target, { text: url, width: 200, height: 200, correctLevel: window.QRCode.CorrectLevel.M });
      } else {
        target.textContent = url;
      }
    }

    function startCountdown() {
      var startedAt = Date.now();
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (!document.body.contains(modal)) { clearInterval(timer); return; }
        var remaining = QR_TTL - Math.floor((Date.now() - startedAt) / 1000);
        var c = document.getElementById('bh-qr-countdown');
        if (remaining <= 0) {
          clearInterval(timer);
          if (c) c.textContent = 'Refreshing…';
          loadFreshCode();
          return;
        }
        if (c) {
          var mm = Math.floor(remaining / 60);
          var ss = remaining % 60;
          c.textContent = 'Refreshes in ' + mm + ':' + (ss < 10 ? '0' : '') + ss;
        }
      }, 1000);
    }

    function loadFreshCode() {
      var c = document.getElementById('bh-qr-countdown');
      if (c) c.textContent = 'Loading…';
      fetchSigninCode().then(function (code) {
        if (!document.body.contains(modal)) return;
        var url = baseUrl;
        if (code) {
          var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
          url = baseUrl + sep + 'signinCode=' + encodeURIComponent(code);
        }
        renderQR(url);
        startCountdown();
      });
    }

    loadFreshCode();
  }

  function getStoreUrl(kind) {
    var el = document.querySelector('[data-bh-cta]');
    if (!el) return '';
    return kind === 'ios' ? (el.dataset.iosStore || '') : (el.dataset.androidStore || '');
  }

  function readVariantMap() {
    var el = document.querySelector('script[data-bh-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch (e) { return []; }
  }

  function currentVariantId() {
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    var qp = new URLSearchParams(window.location.search).get('variant');
    return qp || null;
  }

  function buildUrls(productCta) {
    if (!productCta) return null;
    var map = readVariantMap();
    if (!map.length) return null;
    var vid = currentVariantId();
    var match = null;
    if (vid) {
      for (var i = 0; i < map.length; i++) { if (String(map[i].id) === String(vid)) { match = map[i]; break; } }
    }
    if (!match) match = map[0];
    var ulBase = productCta.getAttribute('data-bh-ul-base') || 'https://enjoy.brighthavenbooks.com';
    var mode = productCta.getAttribute('data-bh-deep-link-mode') || 'home';
    var path = match.type === 'audio' ? '/listen' : '/open';
    var bookIdPrefix = match.type === 'audio' ? 'audio-' : 'ebook-';
    var ulUrl = ulBase + path + '?bookId=' + bookIdPrefix + match.sku;
    var deepLink = mode === 'universal' ? ulUrl : 'brighthaven://';
    return { ulUrl: ulUrl, deepLink: deepLink, match: match };
  }

  function bindCTAs(state) {
    var klass = classifyUser(state);
    document.documentElement.setAttribute('data-bh-user', klass);

    var nodes = document.querySelectorAll('[data-bh-cta-action]');
    for (var i = 0; i < nodes.length; i++) (function (node) {
      var action = node.getAttribute('data-bh-cta-action');
      node.addEventListener('click', function (ev) {
        if (action === 'open-app') {
          ev.preventDefault();
          var productCta = node.closest('.bh-cta-product');
          var urls = buildUrls(productCta);
          var deepLink = urls ? urls.deepLink : node.getAttribute('data-bh-deep-link');
          var ulUrl = urls ? urls.ulUrl : (node.getAttribute('data-bh-ul-url') || deepLink);
          if (!deepLink) { openStore(); return; }
          if (device === 'desktop') {
            showQRModal(ulUrl);
          } else {
            handleMobileClick(deepLink);
          }
        }
      });
    })(nodes[i]);
  }

  function captureReturnTo() {
    var links = document.querySelectorAll('a[data-bh-signin]');
    var ret = window.location.pathname + window.location.search;
    if (window.location.pathname === '/pages/account-information') return;
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        try { sessionStorage.setItem('bh_return_to', ret); } catch (e) {}
      });
    }
  }

  function handleAccountInfoBounce(state) {
    if (window.location.pathname !== '/pages/account-information') return;
    var target = null;
    try { target = sessionStorage.getItem('bh_return_to'); } catch (e) {}
    if (!target || target === '/pages/account-information') return;
    if (state.loggedIn) {
      try { sessionStorage.removeItem('bh_return_to'); } catch (e) {}
      window.location.replace(target);
      return;
    }
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var s = readOutseta();
      if (s.loggedIn) {
        clearInterval(poll);
        try { sessionStorage.removeItem('bh_return_to'); } catch (e) {}
        window.location.replace(target);
      } else if (tries > 600) {
        clearInterval(poll);
      }
    }, 500);
  }

  function init() {
    captureReturnTo();
    var state = readOutseta();
    handleAccountInfoBounce(state);
    resolveStage(state, bindCTAs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
